// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Spinner-module__Loader--QjOFC,
.Spinner-module__Loader--QjOFC:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.Spinner-module__Loader--QjOFC {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 150;
  font-size: 10px;
  position: absolute;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(6,78,135, 0.2);
  border-right: 1.1em solid rgba(6,78,135, 0.2);
  border-bottom: 1.1em solid rgba(6,78,135, 0.2);
  border-left: 1.1em solid #064e87;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: Spinner-module__load8--Oj1b7 1.1s infinite linear;
  animation: Spinner-module__load8--Oj1b7 1.1s infinite linear;
}
@-webkit-keyframes Spinner-module__load8--Oj1b7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes Spinner-module__load8--Oj1b7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/components/UI/Spinner/Spinner.module.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;EAC9C,gCAAgC;EAChC,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,oEAA6C;EAC7C,4DAAqC;AACvC;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF","sourcesContent":[".Loader,\r\n.Loader:after {\r\n  border-radius: 50%;\r\n  width: 10em;\r\n  height: 10em;\r\n}\r\n.Loader {\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  margin: auto;\r\n  z-index: 150;\r\n  font-size: 10px;\r\n  position: absolute;\r\n  text-indent: -9999em;\r\n  border-top: 1.1em solid rgba(6,78,135, 0.2);\r\n  border-right: 1.1em solid rgba(6,78,135, 0.2);\r\n  border-bottom: 1.1em solid rgba(6,78,135, 0.2);\r\n  border-left: 1.1em solid #064e87;\r\n  -webkit-transform: translateZ(0);\r\n  -ms-transform: translateZ(0);\r\n  transform: translateZ(0);\r\n  -webkit-animation: load8 1.1s infinite linear;\r\n  animation: load8 1.1s infinite linear;\r\n}\r\n@-webkit-keyframes load8 {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes load8 {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Loader": `Spinner-module__Loader--QjOFC`,
	"load8": `Spinner-module__load8--Oj1b7`
};
export default ___CSS_LOADER_EXPORT___;
